import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.scss";
import Layout from "./shared/components/Layout";
import usePublicRoutes from "./public/hooks/usePublicRoutes";
import usePublicV2Routes from "./public/hooks/usePublicV2Routes";
import useAccountRoutes from "./account/hooks/useAccountRoutes";
import useAdminRoutes from "./admin/hooks/useAdminRoutes";
import useTechRoutes from "./tech/hooks/useTechRoutes";
import useCustomerRoutes from "./customer/useCustomerRoutes";
import PilotRouteGuard from "./shared/components/PilotRouteGuard";
import { Box } from "@mui/material";

function App() {
  return (
    <Box display="flex" style={{ height: "100%" }}>
      <BrowserRouter>
        <Routes>
          <Route path="public">
            {usePublicRoutes()}
          </Route>

          <Route path="public-v2">
            {usePublicV2Routes()}
          </Route>

          <Route path="account">
            {useAccountRoutes()}
          </Route>

          <Route path="/" element={<Layout />}>
            {/* MidasPilot role: confined to /midas (MIDAS_PILOT_ROLE_SPEC.md §5.2,
                mount point AMENDED 2026-08-18). Mounted HERE rather than inside
                useCustomerRoutes so it covers every Layout child — including the
                `tech` tree, which has no AuthorizedRoute of its own — and every
                sibling added in future. Role-scoped: no other role is affected.
                Deliberately NOT covering /public, /public-v2 (kiosk trees; pilot
                access there is the accepted SEC-REQ-PILOT-4 residual, tenant-scoped)
                or /account (auth flows). UX confinement only — never a security
                boundary; the server-side allowlist + permission seed are. */}
            <Route element={<PilotRouteGuard />}>
              <Route path="admin">{useAdminRoutes()}</Route>
              <Route path="tech">{useTechRoutes()}</Route>
              <Route path="">{useCustomerRoutes()}</Route>
              <Route path="*" element={<Navigate to="" />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </Box>
  );
}

export default App;
